import InputMask from 'react-input-mask';

import cx from 'classnames';

import './FormInput.scss';

export const FormInputWithMask = ({
  name,
  value,
  type = 'text',
  placeholder,
  mask,
  maskChar,
  defaultValue,
  onChange,
  disabled,
  className,
}) => {
  const handleChange = (value) => {
    name ? onChange(name, value) : onChange(value);
  };

  return (
    <div className="form-input__container w-100">
      {placeholder && value && value.length !== 0 ? (
        <span className={cx('form-input__title', { filled: value && value.length !== 0 })}>
          {placeholder}
        </span>
      ) : null}
      <InputMask
        className={cx('form-input', className, {
          with__title: placeholder && value && value.length !== 0,
          disabled: disabled,
        })}
        mask={mask}
        type={type}
        maskChar={maskChar}
        placeholder={placeholder}
        defaultValue={defaultValue}
        value={value}
        onChange={(e) => {
          handleChange(e.target.value);
        }}
      />
    </div>
  );
};
